import { useEffect, useState } from 'react';
import type { LegalDocumentId, PublishedLegalDocument } from '@mbbe/types';
import { apiFetch } from '../lib/apiClient';

export function useLegalDocument(id: LegalDocumentId, enabled = true) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<{ id: string; data?: PublishedLegalDocument; error?: boolean }>({ id });
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setState({ id });
    apiFetch<PublishedLegalDocument>(`/public/legal/${id}`, { signal: controller.signal, cache: 'no-store' })
      .then((data) => { if (!controller.signal.aborted) setState({ id, data }); })
      .catch(() => { if (!controller.signal.aborted) setState({ id, error: true }); });
    return () => controller.abort();
  }, [id, attempt, enabled]);
  return { document: state.id === id ? state.data : undefined, error: state.id === id && state.error, retry: () => setAttempt((n) => n + 1) };
}
